import { render, staticRenderFns } from "./BuyPurchaseHistoryDetail.vue?vue&type=template&id=5e0bee09&scoped=true&"
import script from "./BuyPurchaseHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./BuyPurchaseHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyPurchaseHistoryDetail.vue?vue&type=style&index=0&id=5e0bee09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0bee09",
  null
  
)

export default component.exports